import React, { useRef } from "react";
import { ClipboardList, GraduationCap, Music2, Users } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DEMO_CHOOSER_MODAL, DEMO_CHOOSER_OPTIONS } from "../../lib/demoChooser";
import {
  CLASS_DEMO_CHOOSER_MODAL,
  CLASS_DEMO_CHOOSER_OPTIONS,
} from "../../lib/demoClassChooser";
import { ReadableNavButton } from "../Sticker";
import {
  WorkflowModalBody,
  WorkflowModalHeader,
  WorkflowModalShell,
} from "../workflow/WorkflowModal";

const OPTION_ICONS = {
  guest: Music2,
  host: ClipboardList,
  student: Users,
  instructor: GraduationCap,
};

const MODE_CONFIG = {
  social: {
    title: DEMO_CHOOSER_MODAL.title,
    options: DEMO_CHOOSER_OPTIONS,
    testId: "demo-chooser-modal",
    closeTestId: "demo-chooser-close",
  },
  class: {
    title: CLASS_DEMO_CHOOSER_MODAL.title,
    options: CLASS_DEMO_CHOOSER_OPTIONS,
    testId: "class-demo-chooser-modal",
    closeTestId: "class-demo-chooser-close",
  },
};

export default function DemoChooserModal({ open, mode = "social", onClose }) {
  const dialogRef = useRef(null);
  const nav = useNavigate();
  const titleId = "demo-chooser-title";
  const config = MODE_CONFIG[mode] || MODE_CONFIG.social;

  if (!open) return null;

  function pick(option) {
    nav(option.to);
    onClose();
  }

  return (
    <WorkflowModalShell
      dialogRef={dialogRef}
      onClose={onClose}
      titleId={titleId}
      testId={config.testId}
    >
      <WorkflowModalHeader
        title={config.title}
        titleId={titleId}
        onClose={onClose}
        closeTestId={config.closeTestId}
        sticky
      />
      <WorkflowModalBody className="!space-y-0">
        <fieldset className="border-0 p-0 m-0 min-w-0 flex flex-col gap-2">
          <legend className="sr-only">{config.title}</legend>
          {config.options.map((option) => {
            const Icon = OPTION_ICONS[option.id];
            return (
              <ReadableNavButton
                key={option.id}
                type="button"
                onClick={() => pick(option)}
                className="w-full !items-start !justify-start text-left flex-col gap-1 py-3.5 px-4"
                data-testid={option.testId}
              >
                <span className="flex w-full items-center gap-2.5">
                  {Icon ? (
                    <Icon className="w-4 h-4 shrink-0 text-plum/75" strokeWidth={2.25} aria-hidden />
                  ) : null}
                  <span className="text-[16px] leading-tight text-ink">{option.label}</span>
                </span>
                <span className="w-full text-[14px] font-medium leading-snug text-ink/80 pl-[26px] text-pretty">
                  {option.description}
                </span>
              </ReadableNavButton>
            );
          })}
        </fieldset>
      </WorkflowModalBody>
    </WorkflowModalShell>
  );
}
